export const DEFAULT_ASPECT_RATIO = 16 / 9;

interface ParsedDimension {
  value: number;
  unit: string | null;
}

const parseDimension = (value: string): ParsedDimension | null => {
  if (!value) return null;

  // If it's a percentage, return null as we can't determine true ratio
  if (value.endsWith('%')) return null;

  // Match number and optional unit
  const match = value.match(/^([\d.]+)(\D+)?$/);

  if (!match) return null;

  const numericValue = parseFloat(match[1]);

  if (Number.isNaN(numericValue)) return null;

  // If no unit is specified, assume pixels
  const unit = match[2] || 'px';

  return {
    value: numericValue,
    unit,
  };
};

export const getAspectRatio = ({
  width,
  height,
  style,
}: {
  width: string;
  height: string;
  style: CSSStyleDeclaration;
}) => {
  const widthParsed = parseDimension(width || style.width);
  const heightParsed = parseDimension(height || style.height);

  if (widthParsed && heightParsed && widthParsed.unit === heightParsed.unit) {
    return widthParsed.value / heightParsed.value;
  }

  const aspectRatioString = style.aspectRatio;

  if (aspectRatioString) {
    const [width, height] = aspectRatioString
      .split('/')
      .map((num) => parseFloat(num.trim()));

    return width / height;
  }

  return DEFAULT_ASPECT_RATIO;
};
